import { CdaStructuredTextRecord } from 'react-datocms/structured-text';

import styles from './FeaturesItemBlock.module.css';

interface FeaturesItemBlockRecord extends CdaStructuredTextRecord {
  title?: string;
  subtitle?: string;
}

export default function FeaturesItemBlock({ title, subtitle }: FeaturesItemBlockRecord) {
  return (
    <div className={styles.feature}>
      <div className={styles.title}>{title}</div>
      {subtitle}
    </div>
  );
}
